import { useState } from 'react';
import { Box, Typography, Button, Collapse } from '@mui/material';

// Gemeinsame Anzeige: ein Satz + aufklappbare Dropsätze.
// `dropLabelPrefix` erlaubt die Varianten "Drop ▲" (Trainingsergebnisse) und "▲" (HistoryDialog).
function SatzMitDrops({ satz, idx, drops, dropLabelPrefix = '' }) {
    const [open, setOpen] = useState(false);
    return (
        <Box sx={{ mb: 0.5 }}>
            <Box display="flex" alignItems="center" gap={0.5}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.25 }}>
                    Satz {idx + 1}: {satz.wiederholungen} Wdh @ {satz.gewicht_kg}kg
                </Typography>
                {drops.length > 0 && (
                    <Button
                        size="small"
                        onClick={() => setOpen(o => !o)}
                        sx={{
                            minWidth: 0,
                            p: '0px 6px',
                            fontSize: '0.7rem',
                            color: 'warning.main',
                            textTransform: 'none',
                            lineHeight: 1.4,
                            border: '1px solid',
                            borderColor: 'warning.main',
                            borderRadius: '6px',
                            mb: 0.25,
                        }}
                    >
                        {open ? `${dropLabelPrefix}▲` : `${drops.length} ${dropLabelPrefix}▼`}
                    </Button>
                )}
            </Box>
            <Collapse in={open}>
                {drops.map((ds, dsIdx) => (
                    <Typography
                        key={`drop-${dsIdx}`}
                        variant="body2"
                        sx={{ mb: 0.25, pl: 2, color: 'warning.main', fontSize: '0.8rem' }}
                    >
                        Dropsatz {dsIdx + 1}: {ds.wiederholungen} Wdh @ {ds.gewicht_kg}kg
                    </Typography>
                ))}
            </Collapse>
        </Box>
    );
}

export default SatzMitDrops;
